module.exports = __webpack_public_path__ + "img/Logo.eb309690.png";